















































import {Component, Vue} from "vue-property-decorator";
import Header from "@/components/public/Header.vue";
import Footer from "@/components/public/Footer.vue";
import DemandItem from '@/components/DemandItem.vue'
@Component({
  components:{
    'Header': Header,
    'Footer': Footer,
    'demand-item':DemandItem,
  }
})

export default class Demand extends Vue{

  // 项目列表tabs
  private activeName:any=''

  private demands:any=[];        //破产项目
  private pageInfo:any={
    page: 1,
    size: 6,
    total: 0
  };
  private loading:boolean=false;

  created(){
    this.getProjects()
  }

  public getProjects() {
    this.loading = true;
    let params = {
      ...this.pageInfo
    }
    this.axios.get( this.$URL.DEMAND_LIST, { params }).then((res:any)=>{
      console.log( res.data, '1' )
      this.demands = res.data.list
      this.pageInfo.total = res.data.total
      this.loading = false;
    })
  }

  public handleSizeChange(size:any) {
    this.pageInfo.size = size
  }

  public handleCurrentChange(page:any) {
    this.pageInfo.page = page
    const section = document.getElementById('demand');
    if(section){
      section.scrollIntoView({ behavior: 'smooth' });
    }
    this.getProjects()
  }

}
